export enum MensagensMeioAcessoLogin {
  "Digite seu e-mail" = 1,
  "Digite seu CPF" = 2,
  "Digite seu celular" = 3,
  "Digite o número da sua carteira" = 4
}

export enum MensagensMeioAcessoEsqueciSenha {
  "Digite seu e-mail" = 3,
  "Digite seu CPF" = 1,
  "Digite o número da sua carteira" = 2
}
